import React, { useState, useEffect } from 'react';
import { Modal, Form, Button } from 'antd';
import AceEditor from 'react-ace';
import 'ace-builds/src-noconflict/mode-json';
import 'ace-builds/src-noconflict/theme-github';
import {ActionFlowSubscriptionDTO} from "@/shared/api/model";
import {DataRenderConfig} from "@/modules/action-flow/config/types/dynamic-form-types";

interface DynamicFormConfigModalProps {
    open: boolean;
    onCancel: () => void;
    onSubmit: (config: DataRenderConfig) => void;
    initialConfig?: string;
    subscription: ActionFlowSubscriptionDTO | null;
}

const DynamicFormConfigModal: React.FC<DynamicFormConfigModalProps> = ({
                                                                           open,
                                                                           onCancel,
                                                                           onSubmit,
                                                                           initialConfig,
                                                                       }) => {
    const [form] = Form.useForm();
    const [configJson, setConfigJson] = useState('');

    useEffect(() => {
        if (initialConfig) {
            try {
                // @ts-ignore
                const parsedConfig = JSON.parse(initialConfig);
                setConfigJson(JSON.stringify(parsedConfig, null, 2));
            } catch (error) {
                console.error('Invalid JSON in initialConfig:', error);
                setConfigJson('');
            }
        } else {
            setConfigJson('');
        }
    }, [initialConfig]);

    const handleSubmit = () => {
        try {
            // @ts-ignore
            const config = JSON.parse(configJson.config);
            onSubmit(config);
        } catch (error) {
            console.error('Invalid JSON:', error);
        }
    };

    if(!open) return null;

    return (
        <Modal
            title="Set Dynamic Form Configuration"
            open={open}
            onCancel={onCancel}
            width={1000}
            footer={[
                <Button key="cancel" onClick={onCancel}>
                    Cancel
                </Button>,
                <Button key="submit" type="primary" onClick={handleSubmit}>
                    Submit
                </Button>,
            ]}
        >
            <Form form={form} layout="vertical">
                <Form.Item
                    name="configJson"
                    label="Configuration JSON"
                    rules={[{ required: true, message: 'Please enter the configuration JSON' }]}
                >
                    <AceEditor
                        mode="json"
                        theme="github"
                        onChange={setConfigJson}
                        value={configJson}
                        name="UNIQUE_ID_OF_DIV"
                        editorProps={{ $blockScrolling: true }}
                        setOptions={{
                            useWorker: false,
                            showLineNumbers: true,
                            tabSize: 2,
                        }}
                        style={{ width: '100%', height: '400px' }}
                    />
                </Form.Item>
            </Form>
        </Modal>
    );
};

export default DynamicFormConfigModal;